module.exports = __webpack_public_path__ + "static/media/group_icon3.99f5a6b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/group_icon3.png
// module id = 5066
// module chunks = 0